import { getIconProps, type IconProps } from '#types'

/**
 * Clock icon — time / duration indicator.
 *
 * Clock face with hour/minute hand and small "cap" arcs above representing
 * adjustability/duration. Used for time displays, scheduling, booking times.
 *
 * @example
 * ```tsx
 * <div className="flex items-center gap-2">
 *   <ClockIcon className="h-4 w-4" />
 *   <span>3:00 PM - 4:00 PM</span>
 * </div>
 * ```
 */
export function ClockIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M20.0287 12.1112C20.0287 16.4681 16.4341 20 12 20C7.56589 20 3.97133 16.4681 3.97133 12.1112C3.97133 7.75436 7.56589 4.22244 12 4.22244C16.4341 4.22244 20.0287 7.75436 20.0287 12.1112Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M3 6.41376C3.92156 5.0112 5.17346 3.83787 6.64758 3M17.3524 3C18.8265 3.83787 20.0784 5.0112 21 6.41376M12 8.60509V12.987C12 12.9872 12.0001 12.9875 12.0003 12.9877L13.7841 14.7408"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  )
}
